import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Spin } from "antd";

import AppShell from "./components/layout/AppShell";

// Lazy-loaded pages
const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Chargers = lazy(() => import("./pages/Chargers"));
const ChargerDetails = lazy(() => import("./pages/ChargerDetails"));
const LiveSessions = lazy(() => import("./pages/LiveSessions"));
const Alerts = lazy(() => import("./pages/Alerts"));
const AlertDetails = lazy(() => import("./pages/AlertDetails"));
const Reports = lazy(() => import("./pages/Reports"));
const ReportDetails = lazy(() => import("./pages/ReportDetails"));
const OcppDebug = lazy(() => import("./pages/OcppDebug"));
const Administration = lazy(() => import("./pages/Administration"));
const Support = lazy(() => import("./pages/Support"));

// A simple loading fallback
const PageLoader = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <Spin size="large" />
  </div>
);

function ProtectedApp() {
  const isLoggedIn = localStorage.getItem("navedge_auth") === "true";
  const loginTime = Number(localStorage.getItem("navedge_login_time"));

  const SESSION_LIMIT = 8 * 60 * 60 * 1000; // 8 hours

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!loginTime || Date.now() - loginTime > SESSION_LIMIT) {
    localStorage.removeItem("navedge_auth");
    localStorage.removeItem("navedge_user");
    localStorage.removeItem("navedge_role");
    localStorage.removeItem("navedge_login_time");
    return <Navigate to="/login" replace />;
  }

  return (
    <AppShell>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/chargers" element={<Chargers />} />
          <Route path="/chargers/:id" element={<ChargerDetails />} />
          <Route path="/sessions" element={<LiveSessions />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/alerts/:id" element={<AlertDetails />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/:id" element={<ReportDetails />} />
          <Route path="/debug" element={<OcppDebug />} />
          <Route path="/admin" element={<Administration />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </Suspense>
    </AppShell>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<ProtectedApp />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;